import { render } from "./RandomTiles.vue?vue&type=template&id=1b67aba5&scoped=true"
import script from "./RandomTiles.vue?vue&type=script&lang=js"
export * from "./RandomTiles.vue?vue&type=script&lang=js"

import "./RandomTiles.vue?vue&type=style&index=0&id=1b67aba5&scoped=true&lang=stylus"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b67aba5"]])

export default __exports__